import { unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("关闭");

import { computed, ref, watch } from 'vue';
import { getPrizeEditRecordList } from '@/request';
import { getVexTableProps } from '@/config';
export default {
  name: 'PrizeEditRecordModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['update:modelValue'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const loading = ref(false);
    const tableData = ref([]);
    const tableOptions = getVexTableProps({
      height: 360,
      toolbarConfig: {
        enabled: false
      },
      pagerConfig: {
        enabled: false
      },
      columnConfig: {
        resizable: false
      },
      columns: [{
        title: '更新时间',
        field: 'createAt',
        minWidth: 160
      }, {
        title: '更新人',
        field: 'createBy',
        minWidth: 120,
        showOverflow: true
      }, {
        title: '更新类型',
        field: 'typeStr',
        minWidth: 100
      }, {
        title: '数量',
        field: 'numStr',
        minWidth: 100
      }, {
        title: '效期',
        field: 'expireText',
        minWidth: 120,
        showOverflow: true
      }, {
        title: '价格',
        field: 'priceStr',
        minWidth: 100
      }]
    });
    watch(() => props.modelValue, val => {
      if (val) {
        loadRecordList();
      }
    });

    function loadRecordList() {
      var _props$row;

      if (!((_props$row = props.row) !== null && _props$row !== void 0 && _props$row.merchandiseCansaleId)) {
        tableData.value = [];
        return;
      }

      loading.value = true;
      getPrizeEditRecordList({
        merchandiseCansaleId: props.row.merchandiseCansaleId,
        __warn: true
      }).then(data => {
        tableData.value = data.rows || [];
      }).finally(() => {
        loading.value = false;
      });
    }

    return (_ctx, _cache) => {
      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(visible) ? visible.value = $event : null),
        title: "操作记录",
        width: "860px",
        "destroy-on-close": ""
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        })]),
        default: _withCtx(() => [_unref(visible) ? (_openBlock(), _createBlock(_component_vxe_grid, _mergeProps({
          key: 0
        }, _unref(tableOptions), {
          data: tableData.value,
          loading: loading.value
        }), null, 16, ["data", "loading"])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};